
import axios from "axios"


export const voucherApi = (voucher, url, csrftoken) => {
    const data = {
        "voucher": voucher
    }
    const response = axios({
        method: 'post',
        headers: {
            'X-CSRFToken': csrftoken,
        },
        data,
        url,
    })
    return response
}
